import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { AuthInfoResponse, StatusResponse } from "../../_shared/interfaces";
import PackageJson from "../../../../package.json";

@Component({
  selector: 'app-impressum',
  standalone: true,
  imports: [],
  templateUrl: './impressum.component.html',
  styleUrl: './impressum.component.sass'
})
export class ImpressumComponent implements OnInit {
  version_npm: string;
  version_node: string;
  version_clarity: string;
  version_pps: string;
  production_mode: boolean;
  version_apiUrl: string;
  version_port: number;
  build_number_rms: string = '…';
  build_number_auth: string = '…';

  private get rmsBaseUrl(): string {
    if (!environment.production && environment.stages?.dev && this.isLocalDev()) {
      return '/v1/rest';
    }
    const port = environment.rest.port && environment.rest.port !== 80 && environment.rest.port !== 443
      ? `:${environment.rest.port}` : '';
    return `${environment.rest.protocol}://${environment.rest.apiUrl}${port}/v1/rest`;
  }

  // pps-auth registers /info as a root-level route (like /healthz), not under /v1/auth
  private get authOrigin(): string {
    if (!environment.production && environment.stages?.dev && this.isLocalDev()) {
      return '';
    }
    const env = environment.auth;
    const port = env.port && env.port !== 80 && env.port !== 443 ? `:${env.port}` : '';
    return `${env.protocol}://${env.apiUrl}${port}`;
  }

  private isLocalDev(): boolean {
    if (typeof window === 'undefined') return false;
    const host = window.location.hostname.toLowerCase();
    return host === 'localhost' || host === '127.0.0.1';
  }

  constructor(private http: HttpClient) {
    this.version_npm = environment.versions.npm;
    this.version_node = environment.versions.node;
    this.version_clarity = environment.versions.clarity;
    this.version_pps = PackageJson.version;
    this.production_mode = environment.production;
    this.version_apiUrl = environment.rest.apiUrl;
    this.version_port = environment.rest.port;
  }

  ngOnInit(): void {
    this.http.get<StatusResponse>(`${this.rmsBaseUrl}/status`).subscribe({
      next: r => this.build_number_rms = r.build_number ?? 'unbekannt',
      error: () => this.build_number_rms = 'nicht erreichbar',
    });
    this.http.get<AuthInfoResponse>(`${this.authOrigin}/info`).subscribe({
      next: r => this.build_number_auth = r.build_number ?? 'unbekannt',
      error: () => this.build_number_auth = 'nicht erreichbar',
    });
  }
}
